<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Row>
      <Col span="12">
        <Field :type="2" v-model="fid" :addbtn="true"></Field>
      </Col>
    </Row>

    <br/>
    <br/>
    <br/>
    <br/>
    <img src="@/assets/j1.png"/>

  </div>
</template>

<script>
  import Field from '@/components/common/field/Field'
  export default {
    components:{Field},
    data(){
      return{
        fid:0
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/home/Keywords.vue